import { DOCUMENT } from '@angular/common';
import {Component, HostListener, Inject} from '@angular/core';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body[root]',
  template: `
    <router-outlet></router-outlet>`
})
export class AppComponent {
  constructor(@Inject(DOCUMENT) private document: Document) { }
}
